import webServiceWrapper from './webServiceWrapper';
import { NS_DATABASE_WEBSERVICE, NS_QDABRA_WEBSERVICE } from './dbxl.helpers';

const nses = {
    tns: NS_DATABASE_WEBSERVICE,
    ns2: NS_QDABRA_WEBSERVICE,
};

function getUserInfoWrapper(dataSource, dataConnection) {
    var wrapper = webServiceWrapper(dataSource, dataConnection, nses, [
        'GetUserInfo',
        'GetMyInfo',
    ]);

    var properties;

    function getProperties() {
        var resultNode = wrapper.resultNode();

        if (!resultNode) {
            return;
        }

        var propNodes = wrapper.getServiceElements(resultNode, 'ADProp');
        properties = {};

        propNodes.forEach(function (node) {
            properties[wrapper.getServiceElementValue(node, 'Key')] =
                wrapper.getServiceElementValue(node, 'Value');
        });
    }

    return {
        username: function (value) {
            wrapper.setQueryField('username', value);
        },
        property: function (key) {
            if (!properties) {
                throw new Error('User info has not been queried.');
            }

            return properties[key];
        },
        executeAsync: function () {
            wrapper.executeAsync().then(getProperties);
        },
    };
}

export default getUserInfoWrapper;
